const getDefaultState = (() => ({
    shareCapitalCapitalPaymentData : {},
    shareholderCapitalPaymentCertificatesData: [],
    completeCapitalPaymentData: {},
    capitalPaymentFormId: undefined,
    companyProcessId: undefined,
}));

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        getAll(state)
        {
            return state;
        },

        shareCapitalCapitalPaymentData(state) {
            return state.shareCapitalCapitalPaymentData;
        },

        shareholderCapitalPaymentCertificatesData(state) {
            return state.shareholderCapitalPaymentCertificatesData;
        },

        completeCapitalPaymentData(state) {
            return state.completeCapitalPaymentData;
        },
    },

    mutations: {
        CLEAR(state)
        {
            Object.assign(state, getDefaultState());
        },

        SET_CAPITAL_PAYMENT_DATA(state, shareCapitalCapitalPaymentData) {
            state.shareCapitalCapitalPaymentData = shareCapitalCapitalPaymentData;
        },

        SET_SHAREHOLDER_CAPITAL_PAYMENT_CERTIFICATES_DATA(state, shareholderCapitalPaymentCertificatesData) {
            state.shareholderCapitalPaymentCertificatesData = shareholderCapitalPaymentCertificatesData;
        },

        SET_COMPLETE_CAPITAL_PAYMENT_DATA(state, completeShareBuybackData) {
            state.completeCapitalPaymentData = completeShareBuybackData;
        },

        SET_CAPITAL_PAYMENT_FORM_ID(state, id) {
            state.capitalPaymentFormId = id;
        },

        SET_COMPANY_PROCESS_ID(state, id) {
            state.companyProcessId = id;
        }
    },

    actions: {
        SET_CAPITAL_PAYMENT_FORM_DATA({ commit }, data) {
            commit('CLEAR');
            
            commit('SET_CAPITAL_PAYMENT_DATA', data.share_capital_data);
            commit('SET_SHAREHOLDER_CAPITAL_PAYMENT_CERTIFICATES_DATA', data.certificate_data);
           
            commit('SET_COMPLETE_CAPITAL_PAYMENT_DATA', data.completion_data);
        },
    },
};
